
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';
  import AsDropdown from '@/components/shared/as-dropdown.vue';
  import AsTextWithLabel from '@/components/shared/as-textWithLabel.vue';
  import AsReadWriteBlock from '@/components/shared/as-read-write.vue';
  import AsLabeledBlock from '@/components/shared/as-labeled-block.vue';
  import { HistoryInputDto, LookUpValueType } from '@/apiclient/apiclient_generated';
  import AsMultiSelect from '@/components/shared/as-multi-select.vue';
  import { formatDateWithoutTime } from '@/services/dateFunctions';
  import AsInput from '@/components/shared/as-input.vue';
  import { getFormValueOrDefault } from '@/services/formFunctions';
  import { ButtonTypes } from '@/types/ButtonTypes';
  import AsButton from '@/components/shared/as-button.vue';
  import AsDatepicker from '@/components/shared/as-datepicker.vue';
  import { LookUpValuesModule, LookUpValuesStore } from '@/store/lookUpValues';

  @Options({
    components: {
      AsDropdown,
      AsTextWithLabel,
      AsReadWriteBlock,
      AsLabeledBlock,
      AsMultiSelect,
      AsInput,
      AsDatepicker,
      AsButton,
    },
  })
  export default class ClinicHistoryInputs extends Vue {
    @Prop()
    isReadOnly: boolean;
    @Prop()
    isEditing: boolean;

    bTypes = ButtonTypes;

    newItem: HistoryInputDto;

    @Prop()
    model: HistoryInputDto[];

    private lookUpStore: LookUpValuesModule = LookUpValuesStore;
    lvTypes = LookUpValueType;

    getLookUpOptions(groupType: LookUpValueType) {
      return this.lookUpStore.lookUpOptions(groupType);
    }

    getLookUpValue(group: LookUpValueType, id) {
      return this.lookUpStore.getLookUpValueName({ group, id });
    }

    mounted(): void {
      this.newItem = {} as HistoryInputDto;
    }

    get caseId(): any {
      return this.$route.params.id;
    }

    getFormattedDate(source) {
      return formatDateWithoutTime(source);
    }

    addNewHistoryItem() {
      this.newItem = {} as HistoryInputDto;

      this.model.push(this.newItem);
    }

    removeItem(item) {
      const index = this.model.indexOf(item);

      this.model.splice(index, 1);
    }

    getValueOrDefault(value) {
      return getFormValueOrDefault(value);
    }
  }
